"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _en = _interopRequireDefault(require("../amount/locale/en"));
var _en2 = _interopRequireDefault(require("../cascader/locale/en"));
var _en3 = _interopRequireDefault(require("../chart/locale/en"));
var _en4 = _interopRequireDefault(require("../date-picker/locale/en"));
var _en5 = _interopRequireDefault(require("../day/locale/en"));
var _en6 = _interopRequireDefault(require("../input-ip-address/locale/en"));
var _en7 = _interopRequireDefault(require("../input-ip-range/locale/en"));
var _en8 = _interopRequireDefault(require("../input-ip/locale/en"));
var _en9 = _interopRequireDefault(require("../input-subnet/locale/en"));
var _en10 = _interopRequireDefault(require("../layout/locale/en"));
var _en11 = _interopRequireDefault(require("../location-picker/locale/en"));
var _en12 = _interopRequireDefault(require("../modal/locale/en"));
var _en13 = _interopRequireDefault(require("../notification/locale/en"));
var _en14 = _interopRequireDefault(require("../pagination/locale/en"));
var _en15 = _interopRequireDefault(require("../select-location/locale/en"));
var _en16 = _interopRequireDefault(require("../select/locale/en"));
var _en17 = _interopRequireDefault(require("../sidebar/locale/en"));
var _en18 = _interopRequireDefault(require("../super-search/locale/en"));
var _en19 = _interopRequireDefault(require("../switch/locale/en"));
var _en20 = _interopRequireDefault(require("../tab-select/locale/en"));
var _en21 = _interopRequireDefault(require("../table/locale/en"));
var _en22 = _interopRequireDefault(require("../textarea/locale/en"));
var _en23 = _interopRequireDefault(require("../preset-date-picker/locale/en"));
const locale = {
  Amount: _en.default,
  Cascader: _en2.default,
  Chart: _en3.default,
  DatePicker: _en4.default,
  Day: _en5.default,
  InputIp: _en8.default,
  InputIpAddress: _en6.default,
  InputSubnet: _en9.default,
  InputIpRange: _en7.default,
  Layout: _en10.default,
  LocationPicker: _en11.default,
  Modal: _en12.default,
  Notification: _en13.default,
  Pagination: _en14.default,
  Select: _en16.default,
  SelectLocation: _en15.default,
  Sidebar: _en17.default,
  SuperSearch: _en18.default,
  Switch: _en19.default,
  TabSelect: _en20.default,
  Table: _en21.default,
  Textarea: _en22.default,
  PresetDatePicker: _en23.default
};
var _default = exports.default = locale;